<template>
  <el-dialog
    :title="$t('deleteRechargeSetting.confirmOperation')"
    :visible.sync="dialogVisible"
    width="350px"
    :close-on-click-modal="false">
    <div class="delete-content">
      <p>{{ $t('deleteRechargeSetting.confirmDelete') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('deleteRechargeSetting.cancel') }}</el-button>
      <el-button type="danger" @click="confirmDelete">{{ $t('deleteRechargeSetting.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteRechargeSetting } from '@/api/admin/rechargeSettingApi'

export default {
  name: 'DeleteRechargeSetting',
  data() {
    return {
      dialogVisible: false,
      currentRechargeSetting: null
    }
  },
  methods: {
    open(rechargeSetting) {
      this.dialogVisible = true
      this.currentRechargeSetting = rechargeSetting
    },
    close() {
      this.dialogVisible = false
      this.currentRechargeSetting = null
    },
    confirmDelete() {
      deleteRechargeSetting(this.currentRechargeSetting.id)
        .then(response => {
          if (response.code === '0') {
            this.$message.success(this.$t('deleteRechargeSetting.deleteSuccess'))
            this.close()
            this.$emit('refresh')
          } else {
            this.$message.error(response.msg || this.$t('deleteRechargeSetting.deleteFailed'))
          }
        })
        .catch(error => {
          console.error('删除失败:', error)
          this.$message.error(this.$t('deleteRechargeSetting.deleteFailed'))
        })
    }
  }
}
</script>

<style scoped>
.delete-content {
  padding: 20px 0;
  text-align: center;
}
</style>